import {Modal, notification, Result } from "antd";
import {useContext, useState} from "react";
import {useIntl} from "react-intl";
import { Quote} from "../../api/models";
import {ConfiguratorContext} from "../../context";
import { useQuoteContext } from "../../contexts/QuoteContext";
import BMButton, {BMButtonProps} from "../BMButton";
import useQuote from "../../swr/useQuote";


export const AbandonReviseQuoteButton = (props:Omit<BMButtonProps, 'onChange' | 'onClick'> & {
  onChange?: (q:Quote) => void
}) => {

  const { onChange, ...btnProps } = props;

  const intl = useIntl();
  const configurator = useContext(ConfiguratorContext);
  const {quote} = useQuoteContext();
  const quoteAsync = useQuote({ quoteId: quote?.quoteId, revision: quote?.revision });

  const abandonRevision = async () : Promise<Quote|undefined> => {
    if ( !quote ) return;

    try {

      const resp = await configurator.api.abandonRevision(quote.displayRevisionId );
      return resp.data;
    } catch (e:any) {
      const errorMsg = intl.formatMessage({ id: e.response?.data.message || e.message });
      const msg = "Failed to abandon quote. " + errorMsg;

      notification.error( { message: msg });
    }

    return;
  };

  const [isOpen, setIsOpen] = useState(false);

  const handleClick = async () => {
    const quote = await abandonRevision();
    if ( quote ) {
      props.onChange?.(quote);
    }
    setIsOpen(false);
  }

  return <>
    <BMButton
      {...btnProps} 
      onClick={() => setIsOpen(true)}
    >Abandon</BMButton>
    <Modal
      open={isOpen}
      okText="Confirm"
      onOk={handleClick}
      onCancel={() => setIsOpen(false)}
      confirmLoading={quoteAsync?.isLoading}
      centered
    >
      <Result
        status="info"
        title="This will abandon changes and revert to the previous revision."
      />
    </Modal>
  </>
}


export const ReviseQuoteButton = (props:BMButtonProps) =>  {

  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (e:any) => {
    props.onClick?.(e);
    setIsOpen(false);
  }

  const activeStyle = !props.disabled ? {borderColor: "#1677ff"} : undefined;

  return <>
    <BMButton style={activeStyle} 
      {...props} 
      onClick={() => setIsOpen(true)}
    />
    <Modal
      open={isOpen}
      okText="Confirm"
      onOk={handleClick}
      onCancel={() => setIsOpen(false)}
      centered
    >
      <Result
        status="warning"
        title="Changes will require approval."
      />
    </Modal>
  </>
}


export default ReviseQuoteButton;

